if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // custom code End
        // const sellingPlanId = formData.get('selling_plan');

        // if (sellingPlanId) {
        //   formData.set('quantity', 3);
        // }

        const sellingPlanId = formData.get('selling_plan');
          const quantityInput = this.form.querySelector('[name="quantity"]');

          /*
          * Only subscription purchase should use quantity 3.
          * One-time purchase must remain quantity 1.
          */
          if (sellingPlanId) {
            formData.set('quantity', 3);
          } else {
            formData.set(
              'quantity',
              quantityInput?.value || 1
            );
          }

        // custom code End


        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const variantId = formData.get('id');
      // const quantity = parseInt(formData.get('quantity')) || 1;
        const quantity = parseInt(formData.get('quantity'), 10) || 1;
        const linesUpdateDeferred = this.createCartLinesUpdateEvent(variantId, quantity);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.dispatchCartErrorEvent(response.description || response.message, 'INVALID');
              linesUpdateDeferred?.reject(new Error(response.description || response.message));

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              this.resolveCartLinesUpdate(linesUpdateDeferred);
              window.location = window.routes.cart_url;
              return;
            }

            this.resolveCartLinesUpdate(linesUpdateDeferred);

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            this.dispatchCartErrorEvent(e.message || 'Network error', 'SERVICE_UNAVAILABLE');
            linesUpdateDeferred?.reject(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      createCartLinesUpdateEvent(variantId, quantity) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity }],
            promise: deferred.promise,
          })
        );
        return deferred;
      }

      resolveCartLinesUpdate(deferred) {
        if (!deferred) return;
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return;

        const pendingCartDataPromise = typeof CartItems !== 'undefined'
          ? CartItems.fetchCartData()
          : fetch(`${routes.cart_url}.json`).then((response) => response.json());

        pendingCartDataPromise
          .then((cart) => {
            if (!cart?.currency) return deferred.reject(new Error('Missing currency in cart response'));
            deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
          })
          .catch((e) => deferred.reject(e));
      }

      dispatchCartErrorEvent(message, code) {
        const { CartErrorEvent } = window.StandardEvents || {};
        if (!CartErrorEvent) return;
        this.dispatchEvent(new CartErrorEvent({ error: message, code }));
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}



// default price overwrite 
(function () {
  const interval = setInterval(() => {
    const widget = document.querySelector("recharge-subscription-widget");
    if (!widget?.shadowRoot) return;

    const priceEl = widget.shadowRoot.querySelector(".rc-price");
    if (!priceEl) return;

    // Find the text node containing the price
    const textNode = [...priceEl.childNodes].find(
      node => node.nodeType === Node.TEXT_NODE && node.textContent.trim()
    );

    if (!textNode) return;

    const original = textNode.textContent.trim();

    const match = original.match(/([\d,.]+)/);
    if (!match) return;

    const value = parseFloat(match[1].replace(/,/g, ""));
    const total = (value * 3).toFixed(2);

    textNode.textContent = original.replace(match[1], total);

    // Remove price country code
    widget.shadowRoot.querySelectorAll(".rc-price").forEach((priceEl) => {
      const textNode = [...priceEl.childNodes].find(
        node => node.nodeType === Node.TEXT_NODE && node.textContent.trim()
      );

      if (!textNode) return;

      // Remove trailing currency code (USD, HKD, CAD, AUD, etc.)
      textNode.textContent = textNode.textContent.replace(/\s[A-Z]{3}$/, "");
    });

      // widget.shadowRoot.querySelectorAll(".rc-price").forEach((priceEl) => {
      // const textNode = [...priceEl.childNodes].find(
      // node => node.nodeType === Node.TEXT_NODE && node.textContent.trim()
      // );

      // if (!textNode) return;

      // // Remove trailing currency code (USD, HKD, CAD, AUD, etc.)
      // let text = textNode.textContent.replace(/\s[A-Z]{3}$/, "");

      // // Add a space after the currency symbol
      // text = text.replace(/^([A-Za-z]*\$)/, "$1 ");

      // textNode.textContent = text;
      // });
     // Remove price country code end


    clearInterval(interval);
  }, 200);

    
})();
 
     
/* =========================================================
   SHOP PAY - Recharge Subscription Quantity
   Does NOT affect normal Add to Cart / Cart Drawer
   ========================================================= */

(function () {
  function prepareShopPayQuantity(shopPayContainer) {
    const form = shopPayContainer.closest('form');

    if (!form) {
      console.log('Shop Pay: Product form not found');
      return;
    }

    /*
     * Get the CURRENT selling plan from this product form.
     * Recharge updates this input when subscription/one-time
     * selection changes.
     */
    const sellingPlanInput = form.querySelector(
      'input[name="selling_plan"]'
    );

    const sellingPlanId = sellingPlanInput?.value?.trim() || '';

    /*
     * Find quantity input.
     */
    let quantityInput = form.querySelector(
      'input[name="quantity"]'
    );

    /*
     * Create quantity input only if the form doesn't already have one.
     */
    if (!quantityInput) {
      quantityInput = document.createElement('input');
      quantityInput.type = 'hidden';
      quantityInput.name = 'quantity';

      form.appendChild(quantityInput);
    }

    /*
     * SUBSCRIPTION
     * selling_plan has a value → quantity 3
     */
    if (sellingPlanId) {
      quantityInput.value = '3';

      console.log('SHOP PAY → SUBSCRIPTION', {
        sellingPlan: sellingPlanId,
        quantity: 3
      });
    }

    /*
     * ONE-TIME
     * selling_plan is empty → quantity 1
     */
    else {
      quantityInput.value = '1';

      console.log('SHOP PAY → ONE-TIME', {
        sellingPlan: '',
        quantity: 1
      });
    }

    /*
     * Let Shopify see the latest quantity before
     * accelerated checkout processes the purchase.
     */
    quantityInput.dispatchEvent(
      new Event('input', {
        bubbles: true
      })
    );

    quantityInput.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );
  }

  /*
   * Capture BEFORE Shopify's accelerated checkout
   * handles the interaction.
   */
  document.addEventListener(
    'pointerdown',
    function (event) {
      const shopPayContainer = event.target.closest(
        '.shopify-payment-button'
      );

      if (!shopPayContainer) return;

      prepareShopPayQuantity(shopPayContainer);
    },
    true
  );

  /*
   * Keyboard / fallback handling.
   */
  document.addEventListener(
    'keydown',
    function (event) {
      if (
        event.key !== 'Enter' &&
        event.key !== ' '
      ) {
        return;
      }

      const shopPayContainer = event.target.closest(
        '.shopify-payment-button'
      );

      if (!shopPayContainer) return;

      prepareShopPayQuantity(shopPayContainer);
    },
    true
  );
})();